import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import React, { Component } from "react";
// import { EditorState, ContentState } from "draft-js";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import sanitizeHtml from "sanitize-html";

const TOOLBAR_OPTIONS = {
  options: [
    "inline",
    "blockType",
    "fontSize",
    "list",
    "textAlign",
    "colorPicker",
    "link",
    // "embedded",
    // "image",
    // "remove",
    "history",
  ],
};

class EmailTemplateEditor extends Component {
  constructor(props) {
    super(props);
    let contentBlock;
    // console.log("======CHECK==", this.props.message);
    const html = this.props.message;

    contentBlock = htmlToDraft(html);

    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
        editorHTMLContext: undefined,
      };
    }
  }

  onEditorStateChange = (editorState) => {
    this.setState(
      {
        editorState,
        editorHTMLContext: draftToHtml(
          convertToRaw(editorState.getCurrentContent())
        ).toString(),
      },
      () => {
        console.log("-----HTMLTEMPLATE--", this.state.editorHTMLContext);
        this.props.setTemplateObject({ message: this.state.editorHTMLContext });
      }
    );
  };

  render() {
    const { editorState } = this.state;
    return (
      <div style={{ fontFamily: "none" }}>
        <Editor
          toolbar={TOOLBAR_OPTIONS}
          editorState={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          onEditorStateChange={this.onEditorStateChange}
          onPaste={(e)=>e.clipboardData}
        />
        {/* <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
        /> */}
      </div>
    );
  }
}

export default EmailTemplateEditor;
